
import React from 'react';

import ReactCardFlip from 'react-card-flip';
import { Box, Button, Typography,styled } from '@mui/material';
import Paragraphboxed from './Paragraphboxed';


const CustomTypography = styled(Typography) ({
  
  textAlign: 'start',
  
  color: '#ffffff',
 
  
})




class Cardfliptwo extends React.Component {
  constructor() {
    super();
    this.state = {
      isFlipped: false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.setState((prevState) => ({ isFlipped: !prevState.isFlipped }));
  }

  

  render() {
    return (
      <ReactCardFlip 
        isFlipped={this.state.isFlipped}
        flipDirection="horizontal"
        flipSpeedBackToFront={2}
        flipSpeedFrontToBack={2}
      >
        <Box
          display="flex"
          padding='10px'
          flexWrap="wrap"
          verticalAlign="top"
          background='#000000'
          justifyContent="center"
          minWidth="300px"
          sx={{maxWidth:'33vw',
            '@media (max-width:600px)': {
              minWidth: '95vw',
              maxWidth: '95vw',
            }
          }}
        >
          <img
            src="https://res.cloudinary.com/dpy1up1n6/image/upload/c_scale,w_3000/v1689474635/egress-windows/crank-out-casement-egress-window_3_vnbhco.png"
            width="95%"
            maxWidth='95vw'
          />

<Box
          display="flex"
          padding='10px'
          flexWrap="wrap"
          verticalAlign="top"
          backgroundColor='rgba(0,0,0,0)'
          justifyContent="center"
          minWidth="200px"
          height='85%'
          position='absolute'
          width='85%'
          bottom='20px'
          sx={{maxwidth:'85%',
            '@media (max-width:600px)': {
              minWidth: '85%',
              maxwidth: '85%',
              color:'#ffffff'
            }
          }}>
           <CustomTypography
            sx={{color:'#ffffff'}}>
          <Paragraphboxed
            text="Crank-out Egress Window"
            fontFamily= {"'League Spartan', 'sans-serif'"}
            color='#fff'
            textAlign='center'
            maxwidth='85%'
            padding='10px'            
           
            sx={{
              position:'absolute',
              bottom:'100px',
              left:'40px',
              
            }}
            
           
          />
          </CustomTypography>
          </Box>
          <Button
            sx={{
              background: 'rgba(0,0,0,0.5)',
              borderRadius: '3px',
              border: 'none',
              color: '#eee',
              zIndex:'99999',
              position:'absolute',
              right:'40px',
              bottom:'20px'
            }}
            onClick={this.handleClick}
          >
            Flip
          </Button>
        </Box>

        <Box
          display="flex"
          padding='10px'
          flexWrap="wrap"
          verticalAlign="top"
          background='#000000'
          justifyContent="center"
          minWidth="300px"
          sx={{maxWidth:'33vw',
            '@media (max-width:600px)': {
              minWidth: '95vw',
              maxwidth: '95vw',
            }
          }}
        >
        <img
            src="https://res.cloudinary.com/dpy1up1n6/image/upload/c_scale,w_3000/v1689474635/egress-windows/crank-out-casement-egress-window_3_vnbhco.png"
            alt="crank-out casement egress window"
            width="95%"
            opacity='0.2'
          />
          
          <Box
          display="flex"
          padding='10px'
          flexWrap="wrap"
          verticalAlign="top"
          backgroundColor='rgba(0,0,0,0.6)'
          justifyContent="center"
          minWidth="200px"
          height='85%'
          position='absolute'
          width='85%'
          bottom='20px'
          sx={{maxwidth:'85%',
            '@media (max-width:600px)': {
              minWidth: '85%',
              maxwidth: '85%',
              color:'#ffffff'
            }
          }}>
            <CustomTypography
            sx={{color:'#ffffff'}}>
          <Paragraphboxed
            text={
              'This crank-out casement egress window has fusion-welded seams, a durable egress hinge, and all stainless steal hardware.'
            }
            maxwidth="sm"
            mx={10}
           
            px={10}
            textAlign="left"
            color='#ffffff'
            padding="10px"
            verticalAlign="top"
            
            
            sx={{
            position: 'absolute',
            color: '#$ffffff',
            bottom: '100px',
            left: '20px'
           }}
          />
          </CustomTypography>
          </Box>
          <Button sx={{
            background: 'rgba(0,0,0,0.5)',
            borderRadius: '3px',
            border: 'none',
            color: '#eee',
            zIndex:'99999',
            position:'absolute',
              right:'40px',
              bottom:'20px'
          }}
          
          
          onClick={this.handleClick}>Flip Back</Button>
          
          
          </Box>
      </ReactCardFlip>
    );
  }
}

export default Cardfliptwo;


/*
import React from 'react';
import ReactCardFlip from 'react-card-flip';
import { Box } from '@mui/material';
import Paragraph from './Paragraph';
import Title from './Title'

class Cardflipone extends React.Component {
  constructor() {
    super();
    this.state = {
      isFlipped: false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.setState((prevState) => ({ isFlipped: !prevState.isFlipped }));
  }

  render() {
    return (
      <ReactCardFlip isFlipped={this.state.isFlipped} flipDirection="horizontal"
      flipSpeedBackToFront={2}
        flipSpeedFrontToBack={2}>
        <Box
          display="flex"
          flexWrap="wrap"
          float="top"
          justifyContent="space-evenly"
          minWidth="300px"
          sx={{
            '@media (max-width:600px)': {
              minWidth: '100vw'
            }
          }}
        >
          <img
            src="https://img1.wsimg.com/isteam/ip/39edb80a-a042-4840-a3ba-8c86d177831b/featured-basement-escape-egress-window.png"
            alt="escape egress window"
            width="95%"
          />

          <Paragraph
            text="Escape Egress Window"
            fontFamily="'League Spartan', 'sans-serif'"
            color="#fff"
            textAlign="center"
            maxWidth="90vw"
            padding="10px"
            position='absolute'
            top='200px'
            left='20px'
            
          />

          <button sx= {{
          background:'rgba(0,0,0,0.5)',
          borderRadius:'10px',
          border:'none',
          color:'#fff',
          }}
          onClick={this.handleClick}>See More</button>
        </Box>

        <Box
          display="flex"
          flexDirection={'column'}
          flexWrap="wrap"
          verticalAlign="top"
          borderRadius={'10px'}
          backgroundColor='#000000'
          justifyContent="start"
          minWidth="300px"
          sx={{
            '@media (max-width:600px)': {
              minWidth: '100vw'
            }
          }}
        >
          <Title 
            text={
                'The Single Hung Inswing Casement'
                } 
            textAlign='center'
            padding='4px'
            color='#ffffff'
            position='absolute'
            top='0px'
            
            />
            <Paragraph 
            text={
                'This is, by far, the most innovative, safe, and secure basement egress window.  It operates like a normal single hung window and also includes an inswing casement frame with a solid steel, durable 90% egress hinge.'
            }
            maxWidth = {'sm'}
            mx={0}
            textAlign={'center'}
            color={'#ffffff'}
            padding={'10px'}
            verticalAlign='top'
            />
          

          <button onClick={this.handleClick}>Flip Back</button>
        </Box>
      </ReactCardFlip>
    );
  }
}

export default Cardflipone;

*/



/*
import React from 'react'
import ReactCardFlip from 'react-card-flip';

import { Box } from "@mui/material";
import Paragraph from './Paragraph'

class Cardflipone extends React.Component {
    constructor() {
      super();
        this.state = {
        isFlipped: false
      };
      this.handleClick = this.handleClick.bind(this);
    }
  
    handleClick(e) {
      e.preventDefault();
      this.setState(prevState => ({ isFlipped: !prevState.isFlipped }));
    }
  
    render() {
      return (
        <ReactCardFlip isFlipped={this.state.isFlipped} flipDirection="vertical">
          
          <Box
        display='flex'
        flexWrap='wrap'
        float='top'
        justifyContent='space-evenly'    
        minWidth={'300px'}
        sx={{
          '@media (max-width:600px)': {
            minWidth: '100vw',
          },
        }}
      >
        <img
          src='https://img1.wsimg.com/isteam/ip/39edb80a-a042-4840-a3ba-8c86d177831b/featured-basement-escape-egress-window.png'
          alt="escape egress window"
          width='95%'
        />

         <Paragraph
          text='Escape Egress Window'
          fontFamily={"'League Spartan', 'sans-serif'"}
          color='#121212'
          textAlign='center'
          maxWidth='90vw'
          padding= '10px'
        />

          <button onClick={this.handleClick}>See More</button>
        
      </Box>
            
          
  
          
          <Box
        display='flex'
        flexWrap='wrap'
        float='top'
        justifyContent='space-evenly'    
        minWidth={'300px'}
        sx={{
          '@media (max-width:600px)': {
            minWidth: '100vw',
          },
        }}
      >
        <img
          src='https://img1.wsimg.com/isteam/ip/39edb80a-a042-4840-a3ba-8c86d177831b/featured-basement-escape-egress-window.png'
          alt="escape egress window"
          width='95%'
        />
        <Paragraph
          text='Escape Egress Window'
          fontFamily={"'League Spartan', 'sans-serif'"}
          color='#121212'
          textAlign='center'
          maxWidth='90vw'
          padding= '10px'
        />

         <button onClick={this.handleClick}>Flip Back</button>
      </Box>
            
            
          
        </ReactCardFlip>
      )
    }
  }

  export default Cardflipone

  */